import { forwardRef } from 'react'

import Button, { type ButtonProps } from '..'

type OutlineButtonProps = Omit<ButtonProps, 'appearance'>

const OutlineButton = forwardRef<ButtonProps, OutlineButtonProps>(({ ...props }) => {
  return <Button appearance="bordered" {...props} />
})

OutlineButton.displayName = 'OutlineButton'

export default OutlineButton
